/*************************************/
/* IMPORTS                           */
/*************************************/
import projectImage from '../assets/images/projects/localtribe.png';
import angularImage from '../assets/images/technologies/angular.png';
import reactImage from '../assets/images/technologies/react.png';
import tailwindImage from '../assets/images/technologies/tailwind.svg';

import bootstrapImage from '../assets/images/technologies/bs.png';
import pythonImage from '../assets/images/technologies/python.png';
import rorImage from '../assets/images/technologies/ror.png';
import nginxImage from '../assets/images/technologies/nginx.png';
import ubuntuImage from '../assets/images/technologies/ubuntu.png';
import jsImage from '../assets/images/technologies/js.png';
import wordpressImage from '../assets/images/technologies/wordpress.png';
import postgresqlImage from '../assets/images/technologies/postgresql.png';
import djangoImage from '../assets/images/technologies/django.png';
import phpImage from '../assets/images/technologies/php.png';
import mdcImage from '../assets/images/technologies/mdc.jpeg';
import shopifyImage from '../assets/images/technologies/shopify.png';
import centosImage from '../assets/images/technologies/centos.png';
import apacheImage from '../assets/images/technologies/apache.png';
import mySqlImage from '../assets/images/technologies/mysql.png';
import rubyImage from '../assets/images/technologies/ruby.png';
import angularMaterialImage from '../assets/images/technologies/angular-material.svg';
import polymerImage from '../assets/images/technologies/polymer.png';
import magentoImage from '../assets/images/technologies/magento.png';
import bitbucketImage from '../assets/images/technologies/bitbucket.png';
import githubImage from '../assets/images/technologies/github.png';
import osxImage from '../assets/images/technologies/osx.png';
import linuxImage from '../assets/images/technologies/linux.png';
import jiraImage from '../assets/images/technologies/jira.png';
import trelloImage from '../assets/images/technologies/trello.png';
import slackImage from '../assets/images/technologies/slack.png';
import googleCloudPlatformImage from '../assets/images/technologies/googlecloud.png';
import digitalOceanImage from '../assets/images/technologies/digitalocean.png';
import whmImage from '../assets/images/technologies/whm.png';
import awsImage from '../assets/images/technologies/aws.png';
import fireStoreImage from '../assets/images/technologies/firestore.png';
import fireBaseImage from '../assets/images/technologies/firebase.png';
import visualStudioImage from '../assets/images/technologies/visualstudio.png';
import sublimeImage from '../assets/images/technologies/sublime.png';
import c9Image from '../assets/images/technologies/c9.png';
import atomImage from '../assets/images/technologies/atom.png';
import nextjsImage from '../assets/images/technologies/nextjs.png';

// Project Images
import trofikaImage from '../assets/images/projects/trofika.png';
import localTribeImage from '../assets/images/projects/localtribe.png';
import roomSpaceImage from '../assets/images/projects/roomspace.png';
import evooSanteImg from '../assets/images/projects/evoosante.png';
import nataiResortImage from '../assets/images/projects/natairesort.png';
import tcjImage from '../assets/images/projects/tcj1.png';
import ukRoofingImage from '../assets/images/projects/ukroofing.png';
import macrobioticWorldImage from '../assets/images/projects/macrobioticworld.png';
import brooksStudiosImage from '../assets/images/projects/brooksstudios.png';
import travelBidoImage from '../assets/images/projects/travelbido.png';
import villamarImage from '../assets/images/projects/villamar.png';

// Social SVG Images
import facebookSvgImage from '../assets/images/brand/svg/logo-facebook.svg';
import linkedinSvgImage from '../assets/images/brand/svg/logo-linkedin.svg';
import youtubeSvgImage from '../assets/images/brand/svg/logo-youtube.svg';
import stackoverflowSvgImage from '../assets/images/brand/svg/logo-stackoverflow.svg';
import behanceSvgImage from '../assets/images/brand/svg/logo-behance.svg';
import githubSvgImage from '../assets/images/brand/svg/logo-github.svg';
import twitterSvgImage from '../assets/images/brand/svg/logo-twitter.svg';

/*************************************/
/* PROJECTS DATA                     */
/*************************************/
export const PROJECTS = {
  villmar: {
    shortName: 'Villa Mar',
    title: 'Villa Mar | Cretan Mansion',
    description: 'Experience the elegance & comfort of a traditional Cretan villa.',
    technologies: [{
        tech: 'Ruby On Rails',
        image: rorImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Tailwind',
        image: tailwindImage
      },
    ],
    image: villamarImage,
    livePrevieUrl: 'https://villamar.gr',
    projectDetails: '#',
  },
  trofika: {
    shortName: 'Trofika',
    title: 'Trofika | Farmers Marketplace',
    description: 'Buy farm food directly from farmers near you. Eat healthy food, support farmers.',
    technologies: [{
        tech: 'Ruby On Rails',
        image: rorImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Ubuntu OS',
        image: ubuntuImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
    ],
    image: trofikaImage,
    livePrevieUrl: 'https://trofika.com',
    projectDetails: '#',
  },
  localtribe: {
    shortName: 'Localtribe',
    title: 'localtribe.io | Rent Unused Spaces',
    description: 'Rent your unused spaces. The community marketplace for open (commercial) space rental',
    technologies: [{
        tech: 'Ruby On Rails',
        image: rorImage
      },
      {
        tech: 'Ubuntu OS',
        image: ubuntuImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
    ],
    image: localTribeImage,
    livePrevieUrl: 'https://localtribe.io',
    projectDetails: '#',
  },
  travelbido: {
    shortName: 'Travel Bido',
    title: 'Travel Bido | Cheapest Flights & Hotel Bookings',
    description: 'You will always get the cheapest possible travelbid.',
    technologies: [{
        tech: 'React',
        image: reactImage
      },
      {
        tech: 'Ubuntu OS',
        image: ubuntuImage
      },
      {
        tech: 'JavaScript',
        image: jsImage
      },
    ],
    image: travelBidoImage,
    livePrevieUrl: 'https://travelbido.com',
    projectDetails: '#',
  },
  nataibeach: {
    shortName: 'Natai Resort',
    title: 'Natai Beach Resort & Spa',
    description: 'Resort in Phuket, based on local heritage and traditional Thai culture.',
    technologies: [{
        tech: 'PHP Core',
        image: phpImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Ubuntu OS',
        image: ubuntuImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
    ],
    image: nataiResortImage,
    livePrevieUrl: 'https://natairesort.eliasglyptis.com/',
    projectDetails: '#',
  },
  macrobioticworld: {
    shortName: 'Macrobiotc World',
    title: 'Macrobiotic World',
    description: 'Organic health food shop & store, located in Phuket Thailand. Vegan and non-GMO products.',
    technologies: [{
        tech: 'Shopify',
        image: shopifyImage
      },
      {
        tech: 'Liquid',
        image: shopifyImage
      },
      {
        tech: 'Ruby',
        image: rubyImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Material Design',
        image: mdcImage
      },
    ],
    image: macrobioticWorldImage,
    livePrevieUrl: 'https://macrobioticworld.com',
    projectDetails: '#',
  },
  evoosante: {
    shortName: 'Evoo Sante',
    title: 'Evoo Sante | Catering',
    description: 'Buy farm food directly from farmers near you. Eat healthy food, support farmers.',
    technologies: [{
        tech: 'Python',
        image: pythonImage
      },
      {
        tech: 'Django',
        image: djangoImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Ubuntu OS',
        image: ubuntuImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
    ],
    image: evooSanteImg,
    livePrevieUrl: 'https://evoosante.ca',
    projectDetails: '#',
  },
  roomspace: {
    shortName: 'Roomspace',
    title: 'Roomspace | Serviced Apartments',
    description: 'Serviced apartments in prime locations across London & Portugal.',
    technologies: [{
        tech: 'Wordpress',
        image: wordpressImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Ubuntu OS',
        image: ubuntuImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
    ],
    image: roomSpaceImage,
    livePrevieUrl: 'https://roomspace.com',
    projectDetails: '#',
  },
  thecompletejob: {
    shortName: 'The Complete Job',
    title: 'The Complete Job',
    description: 'Loft conversions & home renos. Specialist wood flooring and glass fibre roofing.',
    technologies: [{
        tech: 'Material Design',
        image: mdcImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Ubuntu OS',
        image: ubuntuImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
    ],
    image: tcjImage,
    livePrevieUrl: 'https://thecompletejob.eliasglyptis.com',
    projectDetails: '#',
  },
  ukroofingsupplies: {
    shortName: 'UK Roofing',
    title: 'UK Roofing & Plastics Supplies',
    description: 'Your leading Roofing Supply Merchant proudly serving the Industry since 1977.',
    technologies: [{
        tech: 'React',
        image: reactImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Tailwind',
        image: tailwindImage
      },
      {
        tech: 'Firebase',
        image: fireBaseImage
      },
      {
        tech: 'Firestore',
        image: fireStoreImage
      },
    ],
    image: ukRoofingImage,
    livePrevieUrl: 'https://ukroofingsupplies.co.uk',
    projectDetails: '#',
  },
  brooksstudios: {
    shortName: 'Brooks Studios',
    title: 'Brooks Studios',
    description: 'Mark is a freelancing filmmaker for wedding films, promotional films & short films.',
    technologies: [{
        tech: 'Wordpress',
        image: wordpressImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'MySql',
        image: mySqlImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Centos OS',
        image: centosImage
      },
      {
        tech: 'Apache',
        image: apacheImage
      },
    ],
    image: brooksStudiosImage,
    livePrevieUrl: 'https://brooksstudios.co.uk',
    projectDetails: '#',
  },
};

/*************************************/
/* SOCIAL MEDIA                      */
/*************************************/
export const SOCIAL = {
  stackoverflow: {
    name: 'Stackoverflow',
    description: 'Follow one the most popular question-and-answer website for computer programmers',
    url: 'https://stackoverflow.com/users/8149936/elias-glyptis',
    image: stackoverflowSvgImage,
  },
  youtube: {
    name: 'Youtube',
    description: 'Follow my youtube channel on how I share everything I learn with everyone else.',
    url: 'https://www.youtube.com/theaworld',
    image: youtubeSvgImage,
  },
  linkedin: {
    name: 'Linkedin',
    description: 'Connect with me on the most popular business and employment-focused social media platform.',
    url: 'https://www.linkedin.com/in/elias-glyptis-663b70102/',
    image: linkedinSvgImage,
  },
  github: {
    name: 'Github',
    description: 'View some of my open source repositories. I can invte to my private repositories as well.',
    url: 'https://github.com/eliasglyptis',
    image: githubSvgImage,
  },
  behance: {
    name: 'Behance',
    description: 'View some of my UX/UI designs on behance.',
    url: 'https://www.behance.net/theaworld',
    image: behanceSvgImage,
  },
  twitter: {
    name: 'Twitter',
    description: 'Follow on Twitter.',
    url: 'https://twitter.com/thea_world',
    image: twitterSvgImage,
  },
  facebook: {
    name: 'Facebook',
    description: 'Follow Facebook posts.',
    url: 'https://www.facebook.com/TheaWorldApps/',
    image: facebookSvgImage,
  },
};

/*************************************/
/* SKILLS DATA                       */
/*************************************/
export const SKILLS = {
  frontEnd: {
    category: 'Front-End Languages, Frameworks & Libraries',
    version: '^7.0.3',
    bootstrap: {
      name: 'Bootstrap',
      version: '> 3.4.1',
      description: 'Bootstrap is a popular front-end framework for building responsive and mobile-first websites. It provides pre-designed CSS and JavaScript components for creating layouts, forms, navigation, and other interface elements.',
      experience: '10 Years',
      image: bootstrapImage,
    },
    tailwind: {
      name: 'Tailwind',
      version: '> 5.0',
      description: 'I love Tailwind because it speeds up development with utility classes, maintains consistency, and eliminates context switching between HTML and CSS files. The inline styles make components self-documenting and easier to maintain, while the purge feature keeps builds tiny.',
      experience: '3 Years',
      image: tailwindImage,
    },
    react: {
      name: 'React',
      version: '^18.2.0',
      description: "React is a declarative, efficient, and flexible JavaScript library for building user interfaces. It enables developers to create reusable UI components that efficiently update and render when data changes. React's virtual DOM optimizes performance by minimizing browser updates, making it popular for building dynamic and interactive web applications.",
      experience: '4 Years',
      image: reactImage,
    },
    nextjs: {
      name: 'NextJS',
      version: '^14.0.0',
      description: 'Next.js is a React framework that enables server-side rendering and static site generation for building fast, SEO-friendly web applications. It offers features like automatic code splitting, optimized performance, and seamless API integration, enhancing both developer experience and end-user performance.',
      experience: '2+ Years',
      image: nextjsImage,
    },
    angular: {
      name: 'Angular',
      version: '^7.0.2',
      description: 'Angular is a platform and framework for building single-page client applications using HTML and TypeScript. It provides a robust structure for organizing code, modular architecture, and powerful tools for development.',
      experience: '1 Year',
      image: angularImage,
    },
    angularMaterial: {
      name: 'Angular Material',
      version: '^2.7.0',
      description: 'Angular Material is a UI component library for Angular applications. It provides a set of reusable and customizable UI components following Material Design principles, such as buttons, cards, forms, and more.',
      experience: '1 Year',
      image: angularMaterialImage,
    },
    polymer: {
      name: 'Polymer',
      version: '^2.7.0',
      description: 'Polymer is a JavaScript library for building web components using modern web standards. It simplifies the creation of reusable and encapsulated UI elements that can be easily integrated into web applications.',
      experience: '2 Months',
      image: polymerImage,
    },
    javascript: {
      name: 'Javascript ES6',
      version: '^2.7.0',
      description: 'JavaScript is a versatile programming language used for creating dynamic and interactive web content. It is commonly used for client-side scripting, adding behavior and interactivity to web pages.',
      experience: '4 Years',
      image: jsImage,
    },
    mdc: {
      name: 'MDC',
      version: '^2.0.0',
      description: 'Material Design Components (MDC) is a set of UI components based on Material Design guidelines. It provides ready-to-use components for building beautiful and consistent user interfaces in web applications.',
      experience: '2 years',
      image: mdcImage,
    },
  },
  backend: {
    category: 'Backend Languages & Frameworks',
    version: '^2.7.0',
    pythonDjango: {
      name: 'Python / Django',
      version: '^3.4.0',
      description: 'Django is a Python-based free and open-source web framework, which follows the model-view-template architectural pattern. Python is a powerful high-end language used for any type of applications.',
      experience: '2 Years',
      image: pythonImage,
    },
    rubyOnRails: {
      name: 'Ruby on Rails',
      version: '^3.4.0',
      description: 'Ruby on Rails (ROR) is a server-side web application framework that includes everything needed to create database-backed web applications according to the Model-View-Controller (MVC) pattern. It empowers developers to build full-blown apps independently.',
      experience: '4 Years',
      image: rorImage,
    },
    phpCore: {
      name: 'PHP Core',
      version: '^3.4.0',
      description: 'PHP Core is a general-purpose programming language for web development. It allows developers to build static to database-driven web pages quickly and effectively. It is essential for many CMSs and web servers like Apache.',
      experience: '1 Year',
      image: phpImage,
    },
  },
  databases: {
    category: 'Databases Relational & Non-Relational',
    version: '^9.6.0',
    postgreSQL: {
      name: 'PostgreSQL',
      version: '^9.6.0',
      description: 'PostgreSQL is an object-relational database management system that extends the SQL language with many features for storing and scaling complex data workloads safely.',
      experience: '4+ Years',
      image: postgresqlImage,
    },
    mySQL: {
      name: 'MySQL',
      version: '^2.2.0',
      description: "MySQL is the world's most popular open-source relational database management system. It offers proven performance, reliability, and ease-of-use for storing and managing structured data.",
      experience: '2+ Years',
      image: mySqlImage,
    },
    firestore: {
      name: 'Firestore',
      description: 'Cloud Firestore is a flexible, scalable database for mobile, web, and server development, offered by Firebase and Google Cloud Platform.',
      experience: '1 Year',
      image: fireBaseImage,
    },
  },
  contentManagementSystemsAndEcommerce: {
    category: 'Content Management Systems & E-commerce',
    shopify: {
      name: 'Shopify',
      version: '^5.1',
      description: 'Shopify is an e-commerce platform that allows businesses to create and manage online stores. It provides a range of customizable templates, tools for managing products, payments, and orders, and integrated marketing features.',
      experience: '3 Years',
      image: shopifyImage,
    },
    wordpress: {
      name: 'WordPress',
      description: 'WordPress is a free and open-source content management system (CMS) based on PHP and MySQL. It is highly customizable and widely used for creating blogs, websites, and online stores with its vast ecosystem of themes and plugins.',
      experience: '3 Years',
      image: wordpressImage,
    },
    magento: {
      name: 'Magento',
      description: 'Magento is an open-source e-commerce platform written in PHP. It offers a range of flexible and scalable solutions for building and managing online stores, including advanced features for product management, customer relations, and marketing.',
      experience: '5 Months',
      image: magentoImage,
    },
  },
  sourceControlAndIssueTracking: {
    category: 'Source Control & Issue Tracking',
    bitbucket: {
      name: 'Bitbucket',
      description: 'Bitbucket is a web-based source code management and collaboration platform built for teams using Git or Mercurial. It offers features like code hosting, version control, pull requests, and issue tracking, all in one place.',
      experience: '> 5 Years',
      image: bitbucketImage,
    },
    github: {
      name: 'GitHub',
      description: 'GitHub is a web-based platform for version control using Git. It provides hosting for software development projects, collaboration features such as pull requests and code review, and integration with other development tools.',
      experience: '> 5 Years',
      image: githubImage,
    },
    jira: {
      name: 'Jira',
      description: 'Jira is an issue tracking and project management tool developed by Atlassian. It allows teams to plan, track, and manage agile software development projects, including bug tracking, issue resolution, and release management.',
      experience: '2 Years',
      image: jiraImage,
    },
    trello: {
      name: 'Trello',
      description: 'Trello is a web-based project management application that uses boards, lists, and cards to organize tasks and projects. It provides a flexible and visual way to collaborate and manage workflows for individuals and teams.',
      experience: '> 5 Years',
      image: trelloImage,
    },
    slack: {
      name: 'Slack',
      description: 'Slack is a collaboration hub that brings teams together to streamline work, automate tasks, and communicate in real-time. It offers channels, messaging, integrations, and file sharing, making it a central platform for team collaboration.',
      experience: '> 5 Years',
      image: slackImage,
    },
  },
  operatingSystems: {
    category: 'Operating Systems',
    ubuntu: {
      name: 'Ubuntu',
      version: '^18.04',
      description: 'Ubuntu is a Linux distribution based on Debian and composed mostly of free and open-source software. It is popular for personal and server use due to its stability, regular updates, and large community support.',
      experience: '> 5 Year',
      image: ubuntuImage,
    },
    centOS: {
      name: 'CentOS',
      description: 'CentOS is a Linux distribution that provides a free, community-supported computing platform compatible with Red Hat Enterprise Linux (RHEL). It is known for its stability, security, and long-term support.',
      experience: '> 5 Years',
      image: centosImage,
    },
    osx: {
      name: 'OSX',
      description: "macOS, formerly known as OS X, is the operating system for Apple's Mac computers. It offers a user-friendly interface, powerful built-in apps, and seamless integration with other Apple devices and services.",
      experience: '> 10 Years',
      image: osxImage,
    },
    linux: {
      name: 'Linux',
      description: 'Linux is a family of open-source Unix-like operating systems based on the Linux kernel. It is widely used in servers, desktops, and embedded devices due to its stability, security, and flexibility.',
      experience: '> 5 Years',
      image: linuxImage,
    },
  },
  cloudInfrastructureServersAndManagers: {
    category: 'Cloud Infrastructure, Servers & Managers',
    googleCloudPlatform: {
      name: 'Google Cloud Platform',
      description: 'Google Cloud Platform (GCP) is a suite of cloud computing services offered by Google. It provides infrastructure as a service (IaaS), platform as a service (PaaS), and software as a service (SaaS) products for computing, storage, and networking.',
      experience: '2 Years',
      image: googleCloudPlatformImage,
    },
    digitalOcean: {
      name: 'Digital Ocean',
      description: 'DigitalOcean is a cloud infrastructure provider that offers cloud computing services to help developers deploy, manage, and scale applications quickly and easily. It specializes in simplicity, performance, and cost-effectiveness for small to medium-sized businesses.',
      experience: '> 5 Years',
      image: digitalOceanImage,
    },
    aws: {
      name: 'AWS',
      description: 'Amazon Web Services (AWS) is a comprehensive cloud computing platform provided by Amazon. It offers a wide range of services including computing power, storage, databases, machine learning, and more, to help businesses scale and grow.',
      experience: '< 1 Year',
      image: awsImage,
    },
    whmCpanel: {
      name: 'WHM & cPanel',
      description: 'WHM (Web Host Manager) and cPanel are web hosting control panels used for managing web hosting servers and websites. WHM provides server administration tools, while cPanel offers a user-friendly interface for website management.',
      experience: '> 5 Years',
      image: whmImage,
    },
  },
  ideAndTextEditors: {
    category: "IDE's & Text Editors",
    visualStudio: {
      name: 'VS Code',
      description: 'Visual Studio is an integrated development environment (IDE) developed by Microsoft. It supports a wide range of programming languages and frameworks, offering tools for code editing, debugging, and project management.',
      experience: '> 5 Years',
      image: visualStudioImage,
    },
    atom: {
      name: 'Atom',
      description: 'Atom is a free and open-source text editor developed by GitHub. It is highly customizable and hackable, with a built-in package manager and a large ecosystem of community-created packages for extending its functionality.',
      experience: '3 Years',
      image: atomImage,
    },
    sublimeText: {
      name: 'Sublime Text',
      description: 'Sublime Text is a sophisticated text editor for code, markup, and prose. It offers a minimalist interface, powerful editing features, and a wide range of plugins for customization and extending its functionality.',
      experience: '5 Years',
      image: sublimeImage,
    },
  },
};

/*************************************/
/* EXPERIENCE DATA (TIMELINE)        */
/*************************************/
export const EXPERIENCE = [{
    date: 'Sept 2024 - Present',
    company: 'Travelmyth',
    role: 'Senior Front End Developer',
    technologies: [{
        tech: 'NextJS 14',
        image: nextjsImage
      },
      {
        tech: 'React JS 18',
        image: reactImage
      },
      {
        tech: 'Zustand',
        image: jsImage
      },
      {
        tech: 'Tailwind',
        image: tailwindImage
      },
    ],
    description: `Migrated from Native React to Next.js 14 to develop high-performance, 
      server-rendered pages. Transition significantly improved SEO and reduced load times 
      via SSR and SSG. Integrated Zustand for efficient state management, simplifying data 
      flow across components. Designed a responsive, accessible UI with TailwindCSS.`,
    link: 'https://travelmyth.com',
  },
  {
    date: '2015',
    company: 'Thea World Inc. - My Startup',
    role: 'Full Stack Developer & Owner',
    technologies: [{
        tech: 'React',
        image: reactImage
      },
      {
        tech: 'Ruby on Rails',
        image: rorImage
      },
    ],
    description: `Played various roles to get the job done, using multiple technologies. 
      Thea World is my own startup.`,
    link: null,
  },
  {
    date: '2023',
    company: 'Villa Mar - Cretan Villa with Booking Engine',
    role: 'Full Stack Developer',
    technologies: [{
        tech: 'Ruby On Rails',
        image: rorImage
      },
      {
        tech: 'Postgresql',
        image: postgresqlImage
      },
      {
        tech: 'Tailwind',
        image: tailwindImage
      },
      {
        tech: 'Vanilla JS',
        image: jsImage
      },
    ],
    description: `Online reservations with a booking engine, calendar and date picker.`,
    link: 'https://villamar.gr',
  },
  {
    date: '2023',
    company: 'Trofika - Farmers Marketplace',
    role: 'Full Stack Developer',
    technologies: [{
        tech: 'Ruby On Rails',
        image: rorImage
      },
      {
        tech: 'Postgresql',
        image: postgresqlImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Vanilla JS',
        image: jsImage
      },
    ],
    description: `Buy farm food directly from farmers near you. Eat healthy food, support farmers.`,
    link: 'https://trofika.com/search?q=',
  },
  {
    date: '2021 - 2022',
    company: 'Sellox Marketplace',
    role: 'Frontend Developer',
    technologies: [{
      tech: 'Angular Material',
      image: angularMaterialImage
    }],
    description: `Built the front end from product requirements using Angular Material. 
      Created reusable UI components to speed up development.`,
    link: 'https://sellox.app',
  },
  {
    date: '2019 - 2021',
    company: 'Macrobiotic World',
    role: 'Full Stack Developer',
    technologies: [{
        tech: 'Shopify',
        image: shopifyImage
      },
      {
        tech: 'Liquid',
        image: shopifyImage
      },
      {
        tech: 'HTML / Rest API',
        image: jsImage
      },
    ],
    description: `Custom-built Shopify ecommerce shop for an organic and whole foods center.`,
    link: 'https://macrobioticworld.com',
  },
  {
    date: '2018 - 2019',
    company: 'Evoo Sante',
    role: 'Full Stack Developer',
    technologies: [{
        tech: 'Python/Django',
        image: djangoImage
      },
      {
        tech: 'Postgresql',
        image: postgresqlImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
      {
        tech: 'Ubuntu',
        image: ubuntuImage
      },
    ],
    description: `Built their food ordering system and the Trofas application with Python/Django.`,
    link: 'https://evoosante.ca/',
  },
  {
    date: '2018 - 2019',
    company: 'Localtribe',
    role: 'Full Stack Developer',
    technologies: [{
        tech: 'Ruby On Rails',
        image: rorImage
      },
      {
        tech: 'Postgresql',
        image: postgresqlImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
      {
        tech: 'Ubuntu',
        image: ubuntuImage
      },
    ],
    description: `Built a collaboration spaces app with Rails. 
      Project is currently awaiting funding to re-launch.`,
    link: 'https://localtribe.io/',
  },
  {
    date: '2018',
    company: 'Natai Beach Resort & Spa',
    role: 'Full Stack Developer (Contract)',
    technologies: [{
        tech: 'PHP Core',
        image: phpImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Postgresql',
        image: postgresqlImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
      {
        tech: 'Ubuntu',
        image: ubuntuImage
      },
    ],
    description: `Built the front end from scratch for a beach resort in Phuket, 
      incorporating local heritage and traditional Thai culture.`,
    link: 'https://natairesort.eliasglyptis.com/',
  },
  {
    date: '2017 - 2018',
    company: 'Travelotto',
    role: 'Full Stack Developer & Business Developer',
    technologies: [{
        tech: 'Angular 6',
        image: angularImage
      },
      {
        tech: 'Firestore',
        image: fireStoreImage
      },
      {
        tech: 'Firebase',
        image: fireBaseImage
      },
    ],
    description: `Thailand's exclusive booking platform (project abandoned due to lack of funding).`,
    link: 'https://supplier-3c912.firebaseapp.com/#/supplier',
  },
  {
    date: '2016 - 2017',
    company: 'Roomspace',
    role: 'Full Stack Web Developer',
    technologies: [{
        tech: 'Wordpress',
        image: wordpressImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'MySQL',
        image: mySqlImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
      {
        tech: 'CentOS / Ubuntu',
        image: ubuntuImage
      },
    ],
    description: `Improved and created new functionality for their WordPress site 
      offering serviced apartments for corporate events.`,
    link: 'https://roomspace.com/',
  },
  {
    date: '2016 - 2017',
    company: 'The Complete Job',
    role: 'Contracted Full Stack Developer',
    technologies: [{
        tech: 'PHP Core',
        image: phpImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Nginx',
        image: nginxImage
      },
      {
        tech: 'Ubuntu',
        image: ubuntuImage
      },
    ],
    description: `Built a home improvements website in PHP core.`,
    link: 'https://thecompletejob.eliasglyptis.com/',
  },
  {
    date: '2016 - 2017',
    company: 'UK Roofing Supplies',
    role: 'Full Stack Web Developer',
    technologies: [{
        tech: 'React',
        image: reactImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'Tailwind',
        image: tailwindImage
      },
      {
        tech: 'Firebase',
        image: fireBaseImage
      },
      {
        tech: 'Firestore',
        image: fireStoreImage
      },
    ],
    description: `Custom CMS & site for a roofing supplier company.`,
    link: 'https://ukroofingsupplies.co.uk/',
  },
  {
    date: '2016 - 2017',
    company: 'Brooks Studios',
    role: 'Full Stack Web Developer',
    technologies: [{
        tech: 'Wordpress',
        image: wordpressImage
      },
      {
        tech: 'Javascript',
        image: jsImage
      },
      {
        tech: 'MySQL',
        image: mySqlImage
      },
      {
        tech: 'Bootstrap',
        image: bootstrapImage
      },
      {
        tech: 'Centos',
        image: centosImage
      },
      {
        tech: 'Apache',
        image: apacheImage
      },
    ],
    description: `Built their website from scratch using PHP core & WordPress for a film producer/freelancer.`,
    link: 'https://brooksstudios.co.uk/',
  },
];
